import request from "@/utils/request";

export function getEvents(params) {
  return request({
    url: `/api/admin/events/`,
    method: `get`,
    params,
  });
}

export function getEventsId(id, params) {
  return request({
    url: `/api/admin/events/${id}/`,
    method: `get`,
    params,
  });
}

export async function postEvents(data) {
  return request({
    url: `/api/admin/events/`,
    method: `post`,
    data,
  });
}

export function patchEventsId(id, data, params = id) {
  return request({
    url: `/api/admin/events/${id}/`,
    method: `patch`,
    params,
    data,
  });
}

export function deleteEvents(id, params) {
  return request({
    url: `/api/admin/events/${id}/`,
    method: "delete",
    params,
  });
}
